import { IconButton, Spacer } from '@chakra-ui/react'
import React, { cloneElement, FC, useCallback, useContext } from 'react'
import { useColor } from '../../theme'
import { HeaderPopoverContext } from './HeaderPopover'
import { ICON_SIZE } from './constants'

interface IHeaderPopoverListItemProps {
  ariaLabel: string
  icon: React.ReactElement
  onClick?: () => void
}
/**
 * Action item for the popover list in the header menu.
 */
export const HeaderPopoverActionItem: FC<IHeaderPopoverListItemProps> = ({
  ariaLabel,
  icon,
  onClick,
}) => {
  const { forceClose } = useContext(HeaderPopoverContext)

  const actionItemColor = useColor({ nuance: 5, palette: 'text' })

  const clonedIcon = cloneElement(icon, {
    boxSize: ICON_SIZE,
  })

  const handleOnClick = useCallback(() => {
    if (onClick) {
      forceClose()
      onClick()
    }
  }, [forceClose, onClick])

  return (
    <>
      <Spacer />
      <IconButton
        aria-label={ariaLabel}
        color={actionItemColor}
        icon={clonedIcon}
        onClick={handleOnClick}
        position="absolute"
        right={2}
        size="headerMenu"
        variant="secondaryHeaderMenu"
      />
    </>
  )
}
